// extracted by mini-css-extract-plugin
export default {"CardBase":"CardBase_CardBase__5RTQ6"};